import { SagaIterator } from 'redux-saga';
import { takeEvery } from '@redux-saga/core/effects';
import {
  fetchGetAllNotificationForPeriodWorker,
  fetchSetAllNotificationIsReadWorker,
  fetchSetNotificationIsReadWorker,
} from './workers';
import {
  fetchGetAllNotificationForPeriod,
  fetchSetAllNotificationIsRead,
  fetchSetNotificationIsRead,
} from '../reducer';

export default function* watcherNotification(): SagaIterator {
  yield takeEvery(
    fetchGetAllNotificationForPeriod,
    fetchGetAllNotificationForPeriodWorker,
  );
  yield takeEvery(
    fetchSetNotificationIsRead,
    fetchSetNotificationIsReadWorker,
  );
  yield takeEvery(
    fetchSetAllNotificationIsRead,
    fetchSetAllNotificationIsReadWorker,
  );
}
